<template>
    <div class="container">
      <div :class="{ 'card-wrapper': true,'alertaVermelho': alerta ? true : false}">
          <v-card class="card-secador">  
              <v-icon class="icon" x-large>mdi-home-silo</v-icon>
              <span class="float-right pr-1 font-weight-bold"> {{item.scdidsecador}} </span>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <div class="mx-auto align-center">
              <div class="linha-menor">
                <div class="mx-auto " v-if="Array.isArray(item.scdidaberturalote)">
                    <span v-for="nro in item.scdidaberturalote" :key="nro.id" 
                    class="mx-auto font-weight-bold justify-space-between font-maior">
                      {{nro}}
                    </span>
                </div>
                <div v-else>
                    <span v-if="item.scdidaberturalote" class="font-weight-bold">{{ item.scdidaberturalote }}</span>
                    <span v-else class="font-weight-bold"> -------- </span>
                </div>

              </div>
            </div>
              <v-divider></v-divider>
            <div class="">
              <div class="linha-menor align-start flex-column">
                <v-btn @click="$_emiteAbastecer" height="20" class="botao green white--text my-2">
                  <v-icon class="mr-2">mdi-grain</v-icon>
                  <span class="font-maior">Abastecimento</span>
                </v-btn>
                <v-btn :disabled="!item.absdatatermino" @click="$_emiteOperacao"
                  height="20" class="botao green white--text my-2">
                  <v-icon class="mr-2">mdi-button-pointer</v-icon>
                  <span class="font-maior">Operação</span>
                </v-btn>
                <v-btn :disabled="
                !(item.status === 'FINALIZADO')" @click="$_emiteArmazenar" 
                  height="20" class="botao green white--text my-2">
                  <v-icon class="mr-2">mdi-barn</v-icon>
                  <span class="font-maior">Armazenamento</span>
                </v-btn>
              </div>
            </div>
              <v-divider></v-divider>
            <div class="linha-menor">
              <div class="d-flex justify-space-between">
                <span> Ultima Umidade </span>
                <span v-if="item.umidade"> {{item.umidade}}% </span>
                <span v-else> -- % </span>
              </div>
              <div class="d-flex justify-space-between">
                <span>Umidade (~) </span>
                <span v-if="item.supostaumidade"> {{item.supostaumidade}}% </span>
                <span v-else> -- % </span>
              </div>
            </div>
              <v-divider></v-divider>

            <div>
              <table class="tabela">
              <tr class='header-tabela'>
                <th class="col1-header">
                  INÍCIO
                </th>
                <th class="col1-header">
                  PREV.
                </th>
                <th class="col1-header">
                  REST.
                </th>
              </tr>

              <!-- 
                FAZER UMA VERIFICAÇÃO PARA APARECER SOMENTE
                QUANDO A DATA DE PREVISÃO ESTÁ PARA OUTRO DIA
                ALÉM DE HOJE 
              -->
              <tr class='claro tabela-interna' >
                <td class="col1">
                  <span v-if="item.datainicio">{{$_geraData(item.datainicio,'DD/MM')}}</span>
                  <span v-else>--/--</span>
                </td>
                <td  class="col1">
                  <span v-if="item.dataprevisao && item.status !== 'DESLIGADO'">{{$_geraData(item.dataprevisao,'DD/MM')}}</span>
                  <span v-else>--/--</span>
                </td>
                <td rowspan="2" class="col1 datarestante" >
                  <span v-if="item.datarestante && item.status !== 'DESLIGADO'">{{item.datarestante}}</span>
                  <span v-else>--:--</span>
                </td>
              </tr>
              <tr class='claro tabela-interna'>
                <td class="col1">
                  <span v-if="item.datainicio">{{$_geraData(item.datainicio,'HH:mm')}}</span>
                  <span v-else>--:--</span>
                </td>
                <td class="col1">
                  <span v-if="item.dataprevisao && item.status !== 'DESLIGADO'">{{$_geraData(item.dataprevisao,'HH:mm')}}</span>
                  <span v-else>--:--</span>
                </td>
<!--                 <td rowspan="2" class="col1" v-if="!$_checkDia(item.datainicio)">
                  <span v-if="item.dataprevisao">{{item.dataprevisao}}</span>
                  <span v-else>--:--</span>
                </td>
                <td rowspan="2" class="col1" v-if="!$_checkDia(item.datainicio)">
                  <span v-if="item.datarestante">{{item.datarestante}}</span>
                  <span v-else>--:--</span>
                </td> -->
              </tr>
              </table>
            </div>
            
            <div v-if="(item.status)" 
              class="linha-fechado"
              :style="{'background-color': $$corStatus}" >
               <b>{{item.status}}</b> 
            </div>
            

            <div v-else 
              class="linha-aberto"
              :style="{'background-color': $$corStatus}"> 
               <b> LIVRE </b> 
            </div> 
          </v-card>
      </div>
    </div>
</template>

<script>
import geraData from '@/utils/geradata';
import db from '@/plugins/dexie';

export default {
  name: 'AppCardMonitoramento',


  props: {
    item: {
      type: Object,
      required: true,
    },
    parametroamostra: {type: Number},
    primeiraamostra: {type: Number},
    stateAlert: {type: Boolean}
  },

  data() {
    return {
      alerta: false,
      amostras: null,
      tipoAlerta: 'alertaVermelho',
      primeiraamostragem:null,
      adicionado: null,
      alertas: []
    }
  },
  computed: {
    $$corStatus() {

      if (['ABASTECENDO','ABASTECIDO'].includes(this.$props.item.status)) return '#347a37';
      else if(this.$props.item.status === 'OPERANDO') return '#F57F17'
      else if(this.$props.item.status === 'DESLIGADO') return '#B71C1C'
      else if(this.$props.item.status === 'FINALIZADO') return '#347a37'
      else if(this.$props.item.status === 'AGENDADO') return '#151d59'
      else {
        return '#4CAF50'
      }
    },
    $$showAbastecimento() {
      if (this.$props.item.secabadatatermino) {
        console.log('JUSSSS', this.$props.item.secsecador)
        return false;
      }
      if (this.$props.item.secidaberturalote) {
        console.log('JU' , this.$props.item.secsecador)
        return true;
      } 
      return false;
    },
    $$showOperacao() {
      if(this.$props.item.secpeso) {
        return true;
      }
      return false
    },
  },

  methods: {
    $_emiteLupa() {
      this.$emit('lupa', this.item)
    },
    $_emiteAbastecer() {
      this.$emit('abastecimento', this.item)
    },
    $_emiteOperacao() {
      this.$emit('operacao', this.item)
    },
    $_emiteArmazenar() {
      this.$emit('armazenamento', this.item)
    },
    $_geraData(data, mask) {
      return geraData(data,mask)
    },
    $_checkDia(data) {
      if (data) {
        const diaAtual = geraData(new Date(), 'DD');
        const diaData = geraData(data, 'DD');
        return diaAtual !== diaData ? true : false;
      } 
    },
    $_conversaoHoraMinuto(data) {
      let split;
      if(data.length > 10) split = (geraData(data,'HH:mm')).split(':');
      else split = data.split(':');

      const hora = parseInt(split[0]) * 60;
      const minuto = parseInt(split[1])
      return hora + minuto
    },
    $_conversaoMinutoHora(minutos, formatacao) {
      const hora = formatacao && Math.floor(minutos / 60) < 10 ? '0' + Math.floor(minutos / 60) : Math.floor(minutos / 60);
      const minuto = formatacao && (minutos % 60) < 10 ? '0' + (minutos % 60) : minutos % 60;
      return `${hora}:${minuto}`
    },
    async $_showAmostras(operacao) {
      //return (await db.amostra.where({amodataoperacao: operacao}).last()).length;
      return (await db.amostra.where({amodataoperacao: operacao}).last()).amodataamostra;
    }
  },

  watch: {
    $$showOperacao: {
      deep: true,
      immediate: true,
      handler() {
      }
    },
    item: {
      deep: true,
      immediate: true,
      async handler() {
        let periodoAmostra;
        /* const camposInseridos = Object.values(this.item).filter((val) => !!val)
        if(camposInseridos.length <= 4) this.alerta = false; */
        if(this.item.datarestante && this.item.previsaomonit) {
          const restante = this.$_conversaoHoraMinuto(this.item?.datarestante)
        const previsao = this.$_conversaoHoraMinuto(this.item?.previsaomonit)
        const novaAmostra = await this.$_showAmostras(this.item.operacao.opedatainicio)
        if (this.amostras && novaAmostra > this.amostras) {
          this.alerta = false;
          this.desativa = true;
          this.$emit('alerta', {excluir: this.item.scdidsecador})
        }
        console.log('amostras',this.amostras, novaAmostra > this.amostras, this.desativa)

        const horaAtivo = this.$_conversaoMinutoHora((previsao - restante), '0');
        const horaPrimeiraAmostra = this.$_conversaoMinutoHora((this.primeiraamostra * 60), true);

        console.log(`${this.item.scdidsecador}º secador`,this.primeiraamostra, horaAtivo, horaPrimeiraAmostra, horaAtivo === horaPrimeiraAmostra,this.primeiraamostragem );
        console.log('monitorando', horaPrimeiraAmostra, horaAtivo, this.$_conversaoHoraMinuto(horaAtivo) > this.$_conversaoHoraMinuto(horaPrimeiraAmostra))
        
        if(horaAtivo === horaPrimeiraAmostra && !this.primeiraamostragem){
          //this.tipoAlerta = 'alertaAzul'
          this.alerta = true
          this.primeiraamostragem = true

        } else if(this.primeiraamostragem || this.$_conversaoHoraMinuto(horaAtivo) > this.$_conversaoHoraMinuto(horaPrimeiraAmostra)) {
          periodoAmostra = (this.$_conversaoHoraMinuto(horaAtivo) % (this.parametroamostra * 60))
          console.log('minutos para amostra',periodoAmostra, this.$_conversaoMinutoHora(this.parametroamostra * 60), horaAtivo)
          if (!this.desativa && periodoAmostra === 0 && (previsao !== restante)) {
            //this.tipoAlerta = 'alertaVermelho'
            this.alerta = true;
            this.$emit('alerta', this.item.scdidsecador)

          }
        }

        if(this.item.datarestante && this.item.supostaumidade) {
          if( this.$_conversaoHoraMinuto(this.item.datarestante) < 2) {
            this.alerta = true;
          }
        }

        if(['FINALIZADO','DESLIGADO','ABASTECIDO','ABASTECENDO', 'LIVRE'].includes(this.item.status)) {
          this.alerta = false;
          this.$emit('alerta', {excluir: this.item.scdidsecador})
        }

        this.amostras = novaAmostra
        if(periodoAmostra > 0 ) this.desativa = false;
        }
      }
    }
  }
}
</script>

<style scoped> 
  .font-maior{
    font-size: 1.1em;
  }
  .topo {
    justify-content: space-between;
  }
  .secador {
    float: right;
  }
  .v-sheet--offset {
    top: 5px;
    position: relative;
  }
  
  .container:first-child {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .card-wrapper {
    display: flex;
  }
  .icon {
    height: 70px;
    font-size: 4vw !important;
  }

  .icon-lupa {
    height: 120px;
    font-size: 1vh !important;
      
  }

  .linha-aberto {
    background-color: #4CAF50;
    color: white;
    height: fit-content;
  }

  .linha-fechado {
    background-color: #c0372e;
    color: white;
    height: fit-content;
  }

  .linha-menor {
    height: 3%;
    min-height: 2%;
    display: block;
    align-items: center;
    justify-content: space-between;
    padding: 0px 5px 0px 5px;
    font-size: 0.7em;
  }

  .card-secador {
    width: fit-content;
    height: fit-content;
    max-width: 12vw;
    margin: 5%;
    text-align: center;
    overflow: hidden;
    position: relative;
    background: linear-gradient(0deg, #fff, #fff);
  }

  .numero {
    font-size: 15px;
    float: right;
    margin: 0;
    padding: 0;
  }

  .botao {
    width: 100%;
    height: 20px;
    font-size: 0.8em;
  }
  
.tabela {
  width: 100%;
  padding: 0px;
  background-color:#6baf4c;
}
.header-tabela {
  width: 100%;
  background-color: #6baf4c;
    color: white;
  font-size: 13px;
}

.col1-header, .col1 {
  width: 16%;
  text-align: center;
}

.datarestante {
  font-size: 1em;
}
.tabela-interna {
  width: 100%;
  font-size: 13px;
  font-weight: bold;
  font-variant-numeric: tabular-nums;
  font-family: 'Courier New', Courier, monospace;

}

.claro {
  background-color: #aac79d;
}

@media screen and (max-width:800px) {
      
      .linha-menor {
        height: 5%;
        display: block;
        align-items: center;
        justify-content: space-between;
        padding: 0px 5px 0px 5px;
        font-size: 0.8em;
      }
      .card-secador {
        position: relative;
        width: fit-content;
        height: fit-content;
        max-width: 40vw;
        overflow: hidden;
        text-align: center;
        background: linear-gradient(0deg, #fff, #fff);
      }
      .icon {
        height: 70px;
        font-size: 50px !important;
      }
      .icon-lupa {
        font-size: 5vw !important;
      }
      .linha-aberto {
        color: white;
        align-content: center;
        height: fit-content;
        min-height: 10%;
      }
    
      .linha-fechado {
        background-color: #c0372e;
        color: white;
        align-content: center;
        margin-top: 0;
        height: fit-content;
        min-height: 10%;
      }
      .botao {
        min-width: 30px !important;
        height: 20px !important ;
        padding-right: 5px !important;
        padding-left: 5px !important;
        font-size: 0.8em;
      }
      .botaoLupa {
        min-width: 30px !important;
        height: 20px !important ;
        padding-right: 10px !important;
        padding-left: 10px !important;
      }
      .datarestante {
        font-size: 0.9em;
      }
      .font-maior{
        font-size: 1em;
      }
    }
  

@media screen and (min-width:1800px) {
      .datarestante {
        font-size: 1.2em;
      }
      .linha-menor {
        height: 2%;
        display: block;
        align-items: center;
        justify-content: space-between;
        padding: 0px 5px 0px 5px;
        font-size: 1em;
      }
      .card-secador {
        min-width: 2vw;
        margin: 5%;
        max-width: 10vw;
        background: linear-gradient(0deg, #fff, #fff);
        text-align: center;     
      }
      .icon {
        height: 60px;
        font-size: 70px !important;
      }
      .icon-lupa {
        font-size: 6vw !important;
      }
      .linha-aberto {
        color: white;
        align-content: center;
        height: fit-content;
        min-height: 10%;
      }

      .linha-fechado {
        background-color: #c0372e;
        color: white;
        align-content: center;
        height: fit-content;
        min-height: 15%;
      }
      .botao {
        min-width: 100% !important;
        height: 20px !important ;
        padding-right: 5px !important;
        padding-left: 5px !important;
        font-size: 0.8em;
      }
      .font-maior {
        font-size: 1.1em;
      }
      .botaoLupa {
        min-width: 30px !important;
        height: 20px !important ;
        padding-right: 10px !important;
        padding-left: 10px !important;
      }
      .tabela {
        width: 100%;
        padding: 0px;
        background-color:#6baf4c;
      }
      .header-tabela {
        width: 100%;
        background-color: #6baf4c;
          color: white;
        font-size: 16px;
      }

      .col1-header, .col1 {
        width: 16%;
        text-align: center;
      }

      .datarestante {
        font-size: 1.1em;
      }
      .tabela-interna {
        font-size: 15px;
      }
    }

  .alertaVermelho {
  width: fit-content;
  height: fit-content;
  position: relative;
  justify-content: center;
  z-index: 2;
  background: transparent;
}

.alertaVermelho:before, .alertaVermelho:after {
  content: '';
	position: absolute;
  z-index: -1;
	background: linear-gradient(90deg,hsl(0, 94%, 49%), #7a0101, #050505);
	background-size: 400%;
  width: 90%;
  align-self: center;
  height: 97%;
  border-radius: 0.5%;
  filter: blur(5px);
	animation: pulse-vermelho 500ms infinite;
}

@keyframes pulse-vermelho {
  0% {
    box-shadow: 0 0 0 0px hsla(0, 98%, 36%, 0.404);
  }
  50% {
    box-shadow: 0 0 0 3px hsla(0, 98%, 36%, 0.404);
  }
  100% {
    box-shadow: 0 0 0 0px hsla(0, 98%, 36%, 0.404);
  }
}
  .alertaAzul {
  width: inherit;
  height: inherit;
  position: relative;
  z-index: 2;
  background: transparent;
  }

.alertaAzul:before, .alertaAzul:after {
  content: '';
	position: absolute;
  z-index: -1;
	background: linear-gradient(90deg,#ff9848, #ff6200, #050505);
	background-size: 400%;
  width: 90%;
  height: 90%;
  border-radius: 1%;
  filter: blur(4px);
	animation: pulse-azul 500ms infinite;
}
@keyframes pulse-azul {
  0% {
    box-shadow: 0 0 0 0px #ff9848;
  }
  50% {
    box-shadow: 0 0 0 5px #ff6200;
  }
  100% {
    box-shadow: 0 0 0 0px #fd2216;
  }
}
</style>